import React from 'react';

export default function useMessageChannel(name: string, onMessage?: (message: MessageEvent) => void) {
  React.useEffect(() => {
    if (!onMessage || !window.electronMessagingApi) {
      return undefined;
    }

    const port = window.electronMessagingApi.subscribeToMessageChannel(name);
    port.addEventListener('message', onMessage);
    port.start();

    return () => {
      port.close();
    };
  }, [name, onMessage]);

  const sendMessage = React.useCallback((message: any) => {
    window.electronMessagingApi?.sendMessage(name, message);
  }, [name]);

  return sendMessage;
}
